import { buildURL, post } from '@/shared/fetch';

// eslint-disable-next-line import/prefer-default-export
export const readAllNotificationsMutationFn = () => {
  return post(buildURL('/notifications/viewed'));
};
